<template>
		<div class="content wrap-page" style="height: auto;">
		<Header></Header>
			<div class="info crfff" style="padding-bottom: 220px;">

        <div style="text-align: center">
          <span class="fs50 w-title ac">{{$t('PiggyBank')}}</span>
        </div>
        <div class="fs33 mt50 ac" v-if="info.left_time==0">{{$t('PiggyBankTips1')}}</div>
        <div class="fs33 mt50 ac" v-else>{{$t('PiggyBankTips12')}}</div>
        <div class="ac">
          <div class="collect-now por mt20" v-if="info.left_time==0" @click="buyRedeem">{{$t('CollectNOW')}}</div>
          <div class="collect-now por mt20" v-else>{{ formatTime(info.left_time) }}</div>
          <div class="mt20">
            <img src="../../static/images/Piggy-Bank.png">
          </div>
        </div>
        <div class="ac bank-font mt20">{{$t('PiggyBankTips2')}}</div>

			</div>
      <div class="home-bottom disflex">
        <div class="bt-icon1" @click="getToNav('book')">
          <img src="../../static/images/mb-ic1.png">
          <span class="">{{$t('books')}}</span>
        </div>
        <div class="bt-icon1 active" @click="getToNav('bank')">
          <img style="margin-top: -25px;" src="../../static/images/mb-ic2-h.png">
          <span class="">{{$t('bank')}}</span>
        </div>
        <div class="bt-icon1 bt-icon2" @click="getToNav('')">
          <img src="../../static/images/mb-ic3.png">
          <span class="">{{$t('home')}}</span>
        </div>
        <div class="bt-icon1" @click="getToNav('shop')">
          <img src="../../static/images/mb-ic4.png">
          <span class="">{{$t('shop')}}</span>
        </div>
        <div class="bt-icon1" @click="getToNav('language')">
          <img src="../../static/images/mb-ic5.png">
          <span class="">{{$t('Settings')}}</span>
        </div>
      </div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {

    getToNav(url){
      this.$router.push({path:'/'+url});
    },
		back(){
			this.$router.go(-1);
		},
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/bank/left_time',null,r =>{
        that.info = r.data
        if(that.info.left_time>0){
          that.countDown(that.info.left_time)
        }
        that.$parent.loadModal(false);
      })
    },
    closeRedeemDialog(){
      this.$refs.redeemDialog.closeMask();
    },
    closeOtpDialog(){
      this.$refs.otpDialog.closeMask();
    },
    buyRedeem(){
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/bank/receive',null,r =>{
      	that.$parent.returnCode(r,function(){
      		that.$parent.loadModal(false);
          if(r.code==1){
            that.getRedeem();

          }

      	});

      })
    },
    formatTime(seconds) {
      const min = Math.floor(seconds / 60).toString().padStart(2, '0');
      const sec = (seconds % 60).toString().padStart(2, '0');
      return `${min}:${sec}`;
    },
    // 计时
    countDown (miao,type){
    	if(miao === 0){
    		this.info.left_time = 0;
    		return;
    	}
    	miao--;
    	this.info.left_time = miao;
    	setTimeout(() =>{
    		this.countDown(miao,type);
    	},1000)
    }
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/bank.vue